import React, { useState } from 'react';
const ObligationData = ({ item }) => {
  return (
    <div className='obligation'>
      <div className='obligation-data'>
        <div>מספר תשלומים שנותרו</div>
        <div></div>
        {item.remainingPayments} מתוך {item.totalInstallmentsNumber}
      </div>
      {item.firstPayment && (
        <div className='obligation-data'>
          <div>תשלום ראשון</div>
          <div></div>₪{item.firstPayment}
        </div>
      )}
      <div className='obligation-data'>
        <div>גובה כל תשלום</div>
        <div></div>₪{item.amountWithVAT}
      </div>
      {/* <div className='border'></div>
      <div className='obligation-data-total'>
        <div>סה״כ לתשלום</div>
        <div className='m-title semi'>₪{parseInt(item.amountWithVAT) * parseInt(item.remainingPayments)}</div>
      </div> */}
    </div>
  );
};
export default ObligationData;
